import React, { Component } from 'react';
import './Loader.css';

class Loader extends Component {
  render() {
    let { visible, on } = this.props;
    return (
      <div className="Loader">
        {[2, 1, 0].map((n) =>
          <i
          key={n}
          className={"Loader__dot" + (visible ? " Loader__dot--visible" : "") + (on ? " Loader__dot--loading" : "")}
          style={{animationDelay: 0.2*n + 's', transitionDelay: 0.2*n + 's'}}></i>)}
      </div>
    );
  }
}

export default Loader;



/** WEBPACK FOOTER **
 ** ./src/components/Loader/index.js
 **/